import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { BaseStationListingFiltersSourceService } from './base-stations-listing-filters-source.service';
import { BaseStationListingDataSourceService } from './base-stations-listing-data-source.service';
import { BaseStationListingExportConfigService } from './base-stations-listing-export-config.service';
import { BaseStationListingModelService } from './base-stations-listing-model.service';

export const provideBaseStationListing = (): (Provider | EnvironmentProviders)[] => [
  BaseStationListingFiltersSourceService,
  BaseStationListingDataSourceService,
  BaseStationListingExportConfigService,
  { provide: LISTING_MODEL, useClass: BaseStationListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
